import { Component,Types } from "ecsy";

export class StarsComponent extends Component {}